/* global  */ // tUrl等のグローバル変数を宣言する

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if ($('.js-t8')[0]) {
  trunk8()
}
function trunk8() {
  // 指定要素に行数制限をかける
  $('.js-t8.line1').trunk8({
    lines: 1,
    fill: '...',
  })
  $('.js-t8.line2').trunk8({
    lines: 2,
    fill: '...',
  })
  $('.js-t8.line3').trunk8({
    lines: 3,
    fill: '...',
  })
  $('.js-t8.line4').trunk8({
    lines: 4,
    fill: '...',
  })
}

if (document.getElementsByClassName('js-swiper-mv-sp')[0]) {
  // MV左側
  const mvSwiperT = new Swiper('.js-swiper-mv-sp', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  })
}

if (document.getElementsByClassName('js-swiper-mv-top')[0]) {
  // MV左側
  const mvSwiperT = new Swiper('.js-swiper-mv-top', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    slidesPerView: 1,
    loop: true,
    autoplay: {
      delay: 3000,
    },
  })

  // MV右側　左側の連動で動かす
  const mvSwiperB = new Swiper('.js-swiper-mv-bottom', {
    speed: 3000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    slidesPerView: 1,
    loop: true,
  })

  mvSwiperT.on('slideChangeTransitionStart', function () {
    let time
    if (mvSwiperT.isEnd) {
      time = 0
    } else {
      time = 1500
    }

    // スライド時のトリガー
    // 下側のスライドを時間差で動かす
    setTimeout(() => {
      mvSwiperB.slideNext()
    }, time)
  })
}

$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

$(function () {
  $(window).scroll(function () {
    let scroll = $(window).scrollTop()
    if (scroll > 0) {
      $('.header').addClass('shadow')
    } else {
      $('.header').removeClass('shadow')
    }
  })
})

if (document.getElementsByClassName('js-topServiceSlideContainer')[0]) {
  var mySwiper = new Swiper('.topServiceContainer', {
    effect: 'slide',
    speed: 3000,
    loop: true,
    freeMode: true,
    centeredSlides: true,
    slidesPerView: 1.25,
    spaceBetween: 25,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3.2,
      },
      1300: {
        slidesPerView: 3.3,
      },
      1400: {
        slidesPerView: 3.6,
      },
      1500: {
        slidesPerView: 3.9,
      },
      1600: {
        slidesPerView: 4.1,
      },
      1700: {
        slidesPerView: 4.3,
      },
      1800: {
        slidesPerView: 4.5,
      },
      1900: {
        slidesPerView: 4.8,
      },
    },
  })
}

// $('.swiper-container').hover(
//   function () {},
//   function () {}
// )

var url = document.getElementById('url').title

$('.topServiceSlide').hover(
  function () {
    mySwiper.autoplay.stop()
    $(this)
      .children('.topServiceSlide__box')
      .children('img')
      .attr('src', url + 'img/open-box.svg')
  },
  function () {
    mySwiper.autoplay.start()
    $(this)
      .children('.topServiceSlide__box')
      .children('img')
      .attr('src', url + 'img/close-box.svg')
  }
)

$('.acc-btn').click(function () {
  $(this).children('.icon-close').toggleClass('show')
  $(this).children('.icon-open').toggleClass('hide')
})

$(function () {
  let count1 = 0
  var until = $('#offset').val()
  var from = until - 10
  // if (until) {
  //   from = until - 9
  // } else {
  //   until = 10
  //   from = until - 9
  // }
  $('.js-sdgs-item').each(function () {
    count1++
    $(this).addClass('show')
    if (count1 == until) {
      return false
    }
  })
  count1 = 0
  if (until > 10) {
    $('.js-sdgs-item').each(function () {
      count1++
      $(this).removeClass('show')
      if (count1 == from) {
        return false
      }
    })
  }
  $('.js-sdgs-link').click(function () {
    $('.js-sdgs-link').removeClass('current')
    $(this).addClass('current')
    $('.js-sdgs-item').removeClass('show')
    let href = $(this).attr('href')
    // $('.' + href).toggleClass('show')
    let count2 = 0
    if (href == 'all') {
      $('.js-sdgs-item').addClass('show')
    } else {
      $('.' + href).each(function () {
        $(this).toggleClass('show')
        count2++
        if (count2 === 10) {
          return false
        }
      })
    }
    return false
  })
})

$(function () {
  if ($('.mw_wp_form_input').length) {
    // if ($('.js-cap').val() == 1) {
    //   $('.js-name-notice').html('※シルク印刷は最大3色、箔押は1色のみお選びいただけます。')
    // }
    $('.js-name-notice').html('※シルク印刷は最大3色、箔押は1色のみお選びいただけます。')
    $('.js-package-notice').html(
      '※箔押はスキンパック以外からお選びください。<br>※スキンパックのお問い合わせの場合、印刷色数のご希望を備考にご記入ください。<br>表裏とも印刷可能です。例）表4色 / 裏1色、表2色 / 裏印刷なし <br>※丸筒・ペンケースのお問い合わせの場合、ペン何本入れご希望かを備考にご記入ください。'
    )
    $('.js-cap').show()
    $('.js-not-cap').hide()
    $('input[name="type"]:radio').change(function () {
      var radioval = $(this).val()
      if (radioval == 1) {
        $('.js-name-notice').html('※シルク印刷は最大3色、箔押は1色のみお選びいただけます。')
        $('.js-package-notice').html(
          '※箔押はスキンパック以外からお選びください。<br>※スキンパックのお問い合わせの場合、印刷色数のご希望を備考にご記入ください。<br>表裏とも印刷可能です。例）表4色 / 裏1色、表2色 / 裏印刷なし <br>※丸筒・ペンケースのお問い合わせの場合、ペン何本入れご希望かを備考にご記入ください。'
        )
        $('.js-cap').show()
        $('.js-not-cap').hide()
      } else if (radioval == 2) {
        $('.js-name-notice').html('※シルク印刷は最大3色お選びいただけます。')
        $('.js-package-notice').html(
          '※スキンパックのお問い合わせの場合、印刷色数のご希望を備考にご記入ください。表裏とも印刷可能です。<br>例）表4色 / 裏1色、表2色  / 裏印刷なし'
        )
        $('.js-cap').hide()
        $('.js-not-cap').show()
      } else {
        $('.js-name-notice').html('※シルク印刷は最大3色お選びいただけます。')
        $('.js-package-notice').html(
          '※箔押はスキンパック以外からお選びください。<br>※スキンパックのお問い合わせの場合、印刷色数のご希望を備考にご記入ください。<br>表裏とも印刷可能です。例）表4色 / 裏1色、表2色 / 裏印刷なし <br>※丸筒・ペンケースのお問い合わせの場合、ペン何本入れご希望かを備考にご記入ください。'
        )
        $('.js-cap').hide()
        $('.js-not-cap').show()
      }
    })
  }
})

// 製品一覧絞込
$(function () {
  // 全てボタン
  $('.js-products-link-all').click(function () {
    $('.js-products-item').show()
    $(this).addClass('current')
    $('.js-products-menu-link').removeClass('current')
    $('.js-products-menu').hide()
    $('.js-products-link').removeClass('current')
  })

  $('.js-products-menu').hide()
  $('.js-products-link').click(function () {
    $('.js-products-link').removeClass('current')
    $('.js-products-link-all').removeClass('current')
    $('.js-products-menu-link').removeClass('current')
    $('.js-products-menu').hide()
    $('.js-products-item').hide()
    $(this).addClass('current')
    let href = $(this).attr('href')
    $('.' + href).show()
    return false
  })
  $('.js-products-menu-link-type').click(function () {
    $(this).toggleClass('current')
    $('.js-products-item').hide()
    $('.js-products-menu-link-type').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      //   console.log(href)
      // }

      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })

  $('.js-products-menu-link-type-sp').click(function () {
    $('.js-products-item').hide()
    $(this).toggleClass('current')
    $('.js-products-menu-link-type-sp').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      // }
      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })

  $('.js-products-menu-link-usage').click(function () {
    $('.js-products-item').hide()
    $(this).toggleClass('current')
    $('.js-products-menu-link-usage').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      // }
      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })

  $('.js-products-menu-link-usage-sp').click(function () {
    $('.js-products-item').hide()
    $(this).toggleClass('current')
    $('.js-products-menu-link-usage-sp').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      // }
      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })

  $('.js-products-menu-link-package').click(function () {
    $('.js-products-item').hide()
    $(this).toggleClass('current')
    $('.js-products-menu-link-package').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      // }
      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })

  $('.js-products-menu-link-package-sp').click(function () {
    $('.js-products-item').hide()
    $(this).toggleClass('current')
    $('.js-products-menu-link-package-sp').each(function () {
      let href = $(this).attr('href')
      // if (!$(this).hasClass('current')) {
      //   $('.' + href).hide()
      // }
      if ($(this).hasClass('current')) {
        $('.' + href).show()
      }
    })
    return false
  })
})

$(function () {})

// $(function () {
//   $('.js-term-check').change(function () {
//     var products = $('.js-term-check').val()
//     console.log(products)
//     if ($('.js-term-check').prop('checked')) {
//       $('.' + products).show()
//     } else {
//       $('.' + products).hide()
//     }
//   })
// })

if (document.getElementById('package')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('package')
  const sliderName = 'package'
  const thumbClass = 'package__thumblist-item'
  const mytap = window.ontouchstart === null ? 'touchstart' : 'click'
  const topWorkSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    autoplay: {
      delay: 3000,
    },
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1, //表示数変更
    spaceBetween: 0, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      el: '.thumblist',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const slides = swiper.slides
        let html = ''
        for (let i = 1; i <= total; i++) {
          if (current === i) {
            html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`
          } else {
            html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`
          }
        }
        return html
      },
    },
  })
  const clickThumbs = () => {
    const thumbItems = document.getElementsByClassName(thumbClass)
    for (let i = 0; i < thumbItems.length; i++) {
      thumbItems[i].addEventListener(
        mytap,
        (e) => {
          let index = e.currentTarget.dataset.slideto
          topWorkSwiper.slideTo(index, 1500, true)
        },
        false
      )
    }
  }

  clickThumbs()
  topWorkSwiper.on('slideChange', clickThumbs)
}

if (document.getElementById('productsSingleItem')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('productsSingleItem')
  const sliderName = 'productsSingleItem'
  const thumbClass = 'productsSingleItem__thumblist-item'
  const mytap = window.ontouchstart === null ? 'touchstart' : 'click'
  const topWorkSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 1000, // アニメ速度
    loop: true, // ループ
    autoplay: true,
    preloadImages: false, // スライド内の画像を読み終えてから開始
    spaceBetween: 1, //スライド同士の間隔を空ける
    centeredSlides: true, // 中央のスライドを基準にする
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      el: '.thumblist',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const slides = swiper.slides
        let html = ''
        for (let i = 1; i <= total; i++) {
          if (current === i) {
            html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`
          } else {
            html = html + `<div class="${thumbClass}" data-slideto="${i}">${slides[i].innerHTML}</div>`
          }
        }
        return html
      },
    },
    // breakpoints: {
    //   768: {
    //     slidesPerView: 1,
    //   },
    // },
  })
  const clickThumbs = () => {
    const thumbItems = document.getElementsByClassName(thumbClass)
    for (let i = 0; i < thumbItems.length; i++) {
      thumbItems[i].addEventListener(
        mytap,
        (e) => {
          let index = e.currentTarget.dataset.slideto
          topWorkSwiper.slideTo(index, 1500, true)
        },
        false
      )
    }
  }

  clickThumbs()
  topWorkSwiper.on('slideChange', clickThumbs)
}

// $(function () {
//   $('.mwform-radio-field').change(function () {
//     console.log('aaa')
//     if (!$(this).children('label').children('input').prop('checked')) {
//       $(this).removeClass('current')
//     }
//     if ($(this).children('label').children('input').prop('checked')) {
//       $(this).addClass('current')
//     }

//     //  } else {
//     //   console.log('外れた')
//     //   $(this).removeClass('current')
//     // }
//   })
// })

//チェックが入ってるのは背景色追加
$('.confirm-btn').html('<span>確認画面へ</span>')
$('.submit-btn').html('<span>送信する</span>')
$(':checked').parent().parent().addClass('current')
//クリックイベント発火
$('.mwform-radio-field')
  .children('label')
  .children('input')
  .click(function (e) {
    var t = e.target.type
    var chk = $(this).prop('checked')
    var name = $(this).attr('name')
    // チェックが入ったか入ってないかで条件分岐
    if (t == 'checkbox') {
      if (chk == true) {
        $(this).parent().parent().removeClass('current')
      } else {
        $(this).parent().parent().addClass('current')
      }
      return true
      //ラジオボタン
    } else if (t == 'radio') {
      if (chk == true) {
        $('input[name=' + name + ']')
          .parent()
          .parent()
          .removeClass('current')
        $(this).parent().parent().addClass('current')
      }
      return true
    }
  })

$(':checked').parent().parent().addClass('current')
//クリックイベント発火
$('.mwform-checkbox-field')
  .children('label')
  .children('input')
  .click(function (e) {
    var t = e.target.type
    var chk = $(this).prop('checked')
    var name = $(this).attr('name')
    // チェックが入ったか入ってないかで条件分岐
    if (t == 'checkbox') {
      if (chk == true) {
        $(this).parent().parent().addClass('current')
      } else {
        $(this).parent().parent().removeClass('current')
      }
      return true
      //ラジオボタン
    } else if (t == 'radio') {
      if (chk == true) {
        $('input[name=' + name + ']')
          .parent()
          .parent()
          .removeClass('current')
        $(this).parent().parent().addClass('current')
      }
      return true
    }
  })

$(function () {
  var href = $('#href').val()
  var num = 0
  $('.contactForm__A-type')
    .children('.mwform-radio-field')
    .each(function () {
      num++
      let src = href + 'img/type' + num + '.jpg'
      var img_element = document.createElement('img')
      img_element.src = src // 画像パス
      $(this).append(img_element)
    })
  num = 0
  $('.contactForm__A-color')
    .children('.mwform-checkbox-field')
    .each(function () {
      num++
      let src = href + 'img/color' + num + '.png'
      var img_element = document.createElement('img')
      img_element.src = src // 画像パス
      $(this).append(img_element)
    })
  num = 0
  $('.contactForm__A-name')
    .children('.mwform-radio-field')
    .each(function () {
      num++
      let src = href + 'img/name' + num + '.png'
      var img_element = document.createElement('img')
      img_element.src = src // 画像パス
      $(this).append(img_element)
    })
  num = 0
  $('.contactForm__A-package')
    .children('.mwform-checkbox-field')
    .each(function () {
      num++
      let src = href + 'img/package' + num + '.jpg'
      var img_element = document.createElement('img')
      img_element.src = src // 画像パス
      $(this).append(img_element)
    })
})

var f_text = document.getElementsByClassName('mwform-checkbox-field-text')

//取得した要素の全角空白を<br>に置換する
for (var i = 0; i < f_text.length; i++) {
  f_text[i].innerHTML = f_text[i].innerHTML.replace(/ /g, '<br>')
}

// $('.mwform-checkbox-field-text').each(function () {
//   var text = $(this).html()
//   $(this).html(text.replace('&lt;br&gt;', '<br>'))
// })

$(function () {
  //.accordion_oneの中の.accordion_headerがクリックされたら
  $('.js-toggle').click(function () {
    $(this).next('.js-toggleBox__inner').slideToggle()
    $(this).toggleClass('open')
  })
})

if (document.getElementsByClassName('js-swiper-relate')[0]) {
  const mvSwiperT = new Swiper('.js-swiper-relate', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1.4,
    spaceBetween: 20,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  })
}

$(function () {
  $('.contactForm__policy--label')
    .find('.mwform-checkbox-field-text')
    .html(
      '<a href="./privacypolicy" style="text-decoration: underline; color: #333333;">個人情報保護方針</a>に同意する'
    )
})

$('.modal-img').modaal({})
